import { render, staticRenderFns } from "./EditPayment.vue?vue&type=template&id=72b0b7e4&scoped=true&"
import script from "./EditPayment.vue?vue&type=script&lang=js&"
export * from "./EditPayment.vue?vue&type=script&lang=js&"
import style0 from "./EditPayment.vue?vue&type=style&index=0&id=72b0b7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0b7e4",
  null
  
)

export default component.exports